import React from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AboutUs from "@/components/AboutUs";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import CoverageMap from "@/components/CoverageMap";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import AIChatbot from "@/components/AIChatbot";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <div className="App min-h-screen bg-white text-zinc-950" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <AboutUs />
        <Services />
        <Pricing />
        <CoverageMap />
        <ContactForm />
      </main>
      <Footer />
      <AIChatbot />
      <CookieBanner />
    </div>
  );
}

export default App;
